export default __webpack_public_path__ + "static/nature-af3a6c9a328d1793e8c21cb571c30b0c.png";